export const texts = {
    labels: {
        course: {
            lessonCount: 'lecke'
        },
        tags: {
            level: {
                beginner: 'kezdő',
                intermediate: 'középhaladó',
                advanced: 'haladó',
                expert: 'profi'
            },
            track: {
                hit: 'sláger',
                playalong: 'zenealap',
                metronome: 'metronóm'
            },
            category: {
                technical: 'technika',
                groove: 'groove',
                fill: 'fill'
            }
        }
    },
    messages: {}
};
//# sourceMappingURL=intl.js.map